<template>
  <div style="margin-top:30PX;" :class="{'mobileAppeal': mobile == 1}">
    <div class="main">
      <div v-if="isTitle == 0 " class="main-title">
        <h2>{{$t('appeal.idResult')}}</h2>
        <p>{{$t('appeal.successfulAppeal')}}</p>
      </div>
      <div v-if="isTitle == 1 " class="main-title">
        <h2>{{$t('appeal.securityInfor')}}</h2>
        <p>{{$t('appeal.chooseEmailP')}}</p>
      </div>
      <div v-if="isTitle == 2 " class="main-title">
        <h2>{{$t('appeal.securityInfor')}}</h2>
        <p v-if="emailActive ==0">{{$t('appeal.bindInfor')}}</p>
        <p v-if="emailActive ==1">{{$t('appeal.SetPassword')}}</p>
      </div>
      <div v-if="isTitle == 3 " class="main-title">
        <h2>{{$t('appeal.securityInfor')}}</h2>
        <p v-if="phoneActive ==0">{{$t('appeal.bindInfor')}}</p>
        <p v-if="phoneActive ==1">{{$t('appeal.SetPassword')}}</p>
      </div>
    </div>
    <div  v-if="!dialogVisible">
    <div class="card-div" v-if="isTitle == 0 ">
      <div class="from-div">
        <h3>{{$t('appeal.passAccount')}}</h3>
        <el-form class="" label-position="rigth" ref="from" :model="from" label-width="220PX">
          <el-form-item :label="$t('help.ContactEmail')" prop="user"  class="contactEmail1">
            <span style="color: #999999!important;line-height:40PX;">{{contactEmail}}</span><br>
            <span style="color: #999999!important;">{{$t('appeal.checkCode')}}</span>
          </el-form-item>
          <el-form-item :error="authnCodeErrorMsg" :label="$t('appeal.recivedCode')" prop="authnCode" class="authorCode"   :rules="{
            required: true, message: $t('appeal.enterAuthoriCode'), trigger: 'blur'
          }">
            <el-input maxlength="8" v-model.trim="from.authnCode" :placeholder="$t('appeal.enterAuthoriCode')"
              style="width:300PX;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-div">
        <el-button class="btn" type="primary" @click="next('from')">{{$t('help.nextStep')}}</el-button>
      </div>
    </div>
    <div class="card-div" v-if="isTitle == 1 ">
      <div v-if="mobile == 0">
        <div style="float: left;width: 350PX;">
          <div class="card-on">
            <img src="../../assets/youxiang.png" class="email-logo" alt="">
            <h2>{{$t('appeal.secureEmail')}}</h2>
            <span>{{$t('appeal.changeInfor')}}</span>
            <div>
              <el-button type="primary" size="medium" v-on:click="emailReset">{{$t('appeal.reset')}}</el-button>
            </div>
          </div>
        </div>
        <div style="float: left;width: 350PX;margin-left:40PX;">
          <div class="card-on">
            <img src="../../assets/shouji.png" class="email-logo" alt="">
            <h2>{{$t('appeal.resetPhone')}}</h2>
            <span>{{$t('appeal.changePhone')}}</span>
            <div>
              <el-button type="primary" size="medium" v-on:click="PhoneReset">{{$t('appeal.reset')}}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mobileEmail">
          <div class="card-on clearfix">
            <img src="../../assets/mobile/youxiang.png" class="email-logo" alt="">
            <h2>{{$t('appeal.secureEmail')}}</h2>
            <div class="text">
              <p>{{$t('appeal.changeInfor')}}</p>
            </div>
            <div class="link" v-on:click="emailReset">
              <a href="javascript:;">{{$t('appeal.reset')}}</a>
              <!-- <img src="../../assets/mobile/jiantou.png" alt=""> -->
            </div>
          </div>
        </div>
        <div class="mobilePhone">
          <div class="card-on clearfix">
            <img src="../../assets/mobile/shouji.png" class="email-logo" alt="">
            <h2>{{$t('appeal.resetPhone')}}</h2>
            <div class="text">
              <p>{{$t('appeal.changePhone')}}</p>
            </div>
            <div class="link" v-on:click="PhoneReset">
              <a href="javascript:;">{{$t('appeal.reset')}}</a>
              <!-- <img src="../../assets/mobile/jiantou.png" alt=""> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-div" v-if="isTitle == 2 ">
      <el-steps :align-center="true" process-status="finish" finish-status="finish" :active="emailActive">
        <el-step icon="el-icon-success" :title="$t('appeal.securityInfor')"></el-step>
        <el-step icon="el-icon-success" :title="$t('appeal.resetPassword')"></el-step>
        <el-step icon="el-icon-success" :title="$t('appeal.completeSet')"></el-step>
      </el-steps>
      <div v-if="emailActive ==0">
        <div class="verificationmode">
          <div class="certer">
            <div class="emailInput equallywh ">
              <input type="text" v-model="email" :placeholder="$t('help.enterEmail')" maxlength="50" class="judgeError">
            </div>
            <div class="makeCode">
              <!-- <div class="leftCode "> -->
                <input @focus="focus" type="text" v-model="emailimgCode" :placeholder="$t('appeal.enterGraphicCode')"
                  class="judgeError emailText">
              <!-- </div> -->
              <!-- <div class="rightCode"> -->
                <img :src="emailimgUrl" @click="newImgHandler" style="height: 100%;cursor: pointer" class="imgCodeE">
              <!-- </div> -->
            </div>
            <div class="equallywhb">
              <p>{{$t('appeal.sentToEmail')}}</p>
            </div>

            <div class="btnObtain equallywh">
              <button :disabled="emailtime > 0" @click="getCode"
                :class="{'btnDis': emailtime > 0}">{{emailtime <= 0 ? $t('appeal.getVCode') : emailtime + 's' + $t('appeal.resend')}}</button>
            </div>
            <div class="btnWrite equallywh ">
              <input @focus="focus" type="text" v-model="emailCode" :placeholder="$t('appeal.enterEmailVerCode')"
                class="judgeError">
            </div>
            <p class="errorMsg redwarn" v-if="emailerrorCode === 1 && isfocus">
              {{$t('appeal.pEnterGraphicCode')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 2 && isfocus">
              {{$t('help.enterEmail')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 3 && isfocus">
              {{$t('appeal.enterEmailVerCode')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 4 && isfocus">
              {{$t('appeal.codeError')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 5 && isfocus">
              {{$t('appeal.requestAgain')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 6 && isfocus">
              {{$t('appeal.verificationCodeError')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="emailerrorCode === 7 && isfocus">
              {{$t('help.incorrectEP')}}
            </p>
            <div class="completeOperation makeCode">
              <div class="returnLeft btnSucc">
                <a href="javascript:;" @click="backEmailActive(0)" class="text-danger" target="_self">
                  {{$t('help.back')}} </a>
              </div>
              <div class="nextRight btnSucc">
                <a href="javascript:;" class="nextTo" target="_self" @click="judgeProgressive"> {{$t('help.nextStep')}}
                </a>
              </div>
            </div>
            <div class="note1">
              <p>{{$t('appeal.note1')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="emailActive ==1">
        <div class="verificationmode">
          <div class="certer">
            <div class="btnWrite equallywh">
              <input @focus="focus" type="password" v-model.trim="newPassword"
                :placeholder="$t('appeal.enterNewPassword')">
            </div>
            <div class="btnWrite equallywh">
              <input @focus="focus" type="password" v-model.trim="newPassword2"
                :placeholder="$t('appeal.surePassword')">
            </div>
            <p style="width: 320PX;color: #999;font-size: 13PX;margin: 10PX;">{{$t('appeal.password8')}}</p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 1 && isfocus">
              {{$t('appeal.emptyCode')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 2 && isfocus">
              {{$t('appeal.twoInconsistencies')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 3 && isfocus">
              {{$t('appeal.passwordNotRules')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 4 && isfocus">
              {{$t('appeal.requestLocked')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 5 && isfocus">
              {{$t('appeal.newExists')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 6 && isfocus">
              {{$t('appeal.incorrectEP')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 7 && isfocus">
              {{$t('appeal.codeFrozen')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 8 && isfocus">
              {{$t('appeal.vCodeError')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 9 && isfocus">
              {{$t('appeal.cheackOk')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 10 && isfocus">
              {{$t('appeal.enterAuthoriCode1')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 11 && isfocus">
              {{$t('appeal.accountNotExist')}}
            </p>
            <p class="errorMsg redwarn" v-if="emailPassErrorCode === 12 && isfocus">
              {{$t('appeal.verificationCodeError')}}
            </p>
            <div class="completeOperation makeCode">
              <div class="returnLeft btnSucc">
                <!-- <button>返回</button> -->
                <a @click="backEmailActive(1)" class="text-danger" target="_self"> {{$t('help.back')}} </a>
              </div>
              <div class="nextRight btnSucc">
                <!-- <button>下一步</button> -->
                <a href="javascript:;" @click="emailNextPas">{{$t('help.nextStep')}}</a>
              </div>
            </div>
            <div class="note1">
              <p>{{$t('appeal.note1')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="emailActive ==2">
        <div class="verificationmode setupSuccess">
          <div class="certer">
            <div style="margin-top:50PX;"><img src="../../assets/success.png" alt=""></div>
          </div>
          <div style="text-align:center">
            <h2>{{$t('appeal.emailSetUp')}}</h2>
            <!-- <span style="margin-top:10PX;display: block;">{{outTime}}{{$t('appeal.returnHome')}}</span> -->
            <span style="margin-top:10PX;display: block;" v-if="this.$i18n.locale !== 'en_US'">{{outTime}}{{$t('appeal.returnHome')}}</span>
            <span style="margin-top:10PX;display: block;" v-else>{{$t('appeal.returnHome')}}&nbsp;&nbsp;{{outTime}}&nbsp;seconds</span>
            <span style="margin-top:10PX;display: block;">{{$t('appeal.accountSet')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-div" v-if="isTitle == 3 ">
      <el-steps :align-center="true" process-status="finish" finish-status="finish" :active="phoneActive">
        <el-step icon="el-icon-success" :title="$t('appeal.securityInfor')"></el-step>
        <el-step icon="el-icon-success" :title="$t('appeal.resetPassword')"></el-step>
        <el-step icon="el-icon-success" :title="$t('appeal.completeSet')"></el-step>
      </el-steps>
      <div v-if="phoneActive ==0">
        <div class="verificationmode">
          <div class="certer">
            <div class="regionphone equallywh" style="display: none">
              <input type="text">
            </div>
            <div class="numberphone equallywh">
              <input maxlength="11" type="text" v-model="phone" :placeholder="$t('appeal.enterPhoneCode')">
            </div>
            <div class="makeCode">
              <!-- <div class="leftCode"> -->
                <input @focus="focus" type="text" :placeholder="$t('appeal.enterGraphicCode')" v-model="imgCode" class="emailText">
              <!-- </div> -->
              <!-- <div class="rightCode"> -->
                <img :src="imgUrl" @click="newImgHandler" style="height: 100%;cursor: pointer" class="imgCodeE">
              <!-- </div> -->
            </div>
            <div class="equallywhb">
              <p>{{$t('appeal.SentToPhone')}}</p>
            </div>

            <div class="btnObtain equallywh">
              <button @click="getCode"
                :class="{'btnDis': time > 0}">{{time <= 0 ? $t('help.getCode') : time + 's' + $t('appeal.resend')}}</button>
              <!-- <input type="button" value="获取验证码"> -->
            </div>
            <div class="btnWrite equallywh">
              <input @focus="focus" type="text" v-model="code" :placeholder="$t('appeal.SMSCode')">
            </div>
            <p class="errorMsg redwarn" v-if="PhoneErrorCode === 1 && isfocus">
              {{$t('appeal.pEnterGraphicCode')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 2 && isfocus">
              {{$t('appeal.enterPhoneCode')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 3 && isfocus">
              {{$t('appeal.SMSCode')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 4 && isfocus">
              {{$t('appeal.codeError')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 5 && isfocus">
              {{$t('appeal.requestAgain')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 6 && isfocus">
              {{$t('appeal.verificationCodeError')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 7 && isfocus">
              {{$t('help.incorrectPhone')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 8 && isfocus">
              {{$t('appeal.authorizationError')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 9 && isfocus">
              {{$t('appeal.ACodeExpired')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 10 && isfocus">
              {{$t('help.incorrectPhone')}}
            </p>
            <p class="errorMsg redwarn" v-else-if="PhoneErrorCode === 12 && isfocus">
              {{$t('appeal.verificationCodeError')}}
            </p>
            <div class="completeOperation makeCode">
              <div class="returnLeft btnSucc">
                <!-- <button>返回</button> -->
                <a @click="backphoneActive(0)" class="text-danger" target="_self"> {{$t('help.back')}} </a>
              </div>
              <div class="nextRight btnSucc">
                <!-- <button>下一步</button> -->
                <a href="javascript:;" @click="validCodeHandler">{{$t('help.nextStep')}}</a>
              </div>
            </div>
            <div class="note1">
              <p>{{$t('appeal.note1')}}</p>
            </div>
          </div>

        </div>
      </div>
      <div v-if="phoneActive ==1">
        <div class="verificationmode">
          <div class="certer">
            <div class="btnWrite equallywh">
              <input @focus="focus" type="password" v-model.trim="phoneNnewPassword"
                :placeholder="$t('appeal.enterNewPassword')">
            </div>
            <div class="btnWrite equallywh">
              <input @focus="focus" type="password" v-model.trim="phoneNnewPassword2"
                :placeholder="$t('appeal.surePassword')">
            </div>
            <p style="width: 320PX;color: #999;font-size: 13PX;margin: 10PX;">{{$t('appeal.password8')}}</p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 1 && isfocus">
              {{$t('appeal.emptyCode')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 2 && isfocus">
              {{$t('appeal.twoInconsistencies')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 3 && isfocus">
              {{$t('appeal.passwordNotRules')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 4 && isfocus">
              {{$t('appeal.requestLocked')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 5 && isfocus">
              {{$t('appeal.newExists')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 6 && isfocus">
              {{$t('appeal.incorrectEP')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 7 && isfocus">
              {{$t('appeal.codeFrozen')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 8 && isfocus">
              {{$t('appeal.SmSError')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 9 && isfocus">
              {{$t('appeal.cheackOk')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 10 && isfocus">
              {{$t('appeal.enterAuthoriCode1')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 11 && isfocus">
              {{$t('appeal.accountNotExist')}}
            </p>
            <p class="errorMsg redwarn" v-if="phonePassErrorCode === 12 && isfocus">
              {{$t('appeal.verificationCodeError')}}
            </p>
            <div class="completeOperation makeCode">
              <div class="returnLeft btnSucc">
                <!-- <button>返回</button> -->
                <a @click="backphoneActive(1)" class="text-danger" target="_self"> {{$t('help.back')}} </a>
              </div>
              <div class="nextRight btnSucc">
                <!-- <button>下一步</button> -->
                <a href="javascript:;" @click="nextPas">{{$t('help.nextStep')}}</a>
              </div>
            </div>
            <div class="note1">
              <p>{{$t('appeal.note1')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="phoneActive ==2">
        <div class="verificationmode setupSuccess">
          <div class="certer">
            <div style="margin-top:50PX;"><img src="../../assets/success.png" alt=""></div>
          </div>
          <div style="text-align:center">
            <h2>{{$t('appeal.phoneSetUp')}}</h2>
            <span style="margin-top:10PX;display: block;" v-if="this.$i18n.locale !== 'en_US'">{{outTime}}{{$t('appeal.returnHome')}}</span>
            <span style="margin-top:10PX;display: block;" v-else>{{$t('appeal.returnHome')}}&nbsp;&nbsp;{{outTime}}&nbsp;seconds</span>
            <span style="margin-top:10PX;display: block;">{{$t('appeal.accountSet')}}</span>
          </div>
        </div>
      </div>
    </div>
</div>
    
    <div v-if="dialogVisible">
      <div class="dialogLink">
        <span class="DialoglinkExpired">{{$t('appeal.linkExpired')}} </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="errOk ">{{$t('help.sure')}}</el-button>
        </span>
      </div>
    </div>
    <!-- <el-dialog title="" :visible.sync="dialogVisible" width="30%" :center="true" :fullscreen="true" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <Header :mobile="$store.state.MobileStatue"></Header>
      <span>{{$t('appeal.linkExpired')}} </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errOk ">{{$t('help.sure')}}</el-button>
      </span>
    </el-dialog> -->
  </div>

</template>

<script>
  import {
    isEmail,
    isPsw,
    isMobile
  } from "../../utils/validate";
  import {
    setCapture
  } from "../../utils";
  import apiUrl from '@/utils/api' //api 接口
  import Header from '../common/header'

  export default {
    //import引入的组件需要注入到对象中才能使用
    props: ['mobile'],
    components: {
      Header
    },
    data() {
      //这里存放数据
      return {
        outTime: 3,
        dialogVisible: false,
        phoneNnewPassword2: "",
        phoneNnewPassword: '',
        emailCode: '',
        emailerrorCode: 0,
        phonePassErrorCode: 0,
        PhoneErrorCode: 0,
        emailPassErrorCode: 0,
        verifyToken: "",
        authnCodeErrorMsg: "",
        emailtime: 0,
        email: '',
        emailimgUrl: '',
        emailimgCode: '',
        emailcode: '',
        emailflag: true,
        isfocus: false,
        newPassword: "",
        newPassword2: '',
        imgCode: '',
        phone: '',
        code: '',
        imgUrl: '',
        ttt: new Date().getTime(),
        time: 0,
        type: 3,
        flag: true,
        areacode: '+86',
        isTitle: 0,
        contactEmail: "",
        userId: "",
        iscode: false,
        phoneActive: 0,
        emailActive: 0,
        from: {
          userName: "asdad@121212.com",
          userId: "",
          authnCode: ""
        },

      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      errOk() {
        location.href = this.$baseUrl + "home-page"
      },
      emailNextPas() {
        this.emailPassErrorCode = 0
        if (!this.newPassword && !this.newPassword2) {
          this.emailPassErrorCode = 1
          this.isfocus = true
        } else if (this.newPassword != this.newPassword2) {
          this.emailPassErrorCode = 2
          this.isfocus = true
        } else if (!isPsw(this.newPassword)) {
          this.emailPassErrorCode = 3
          this.isfocus = true
        } else {
          this.$http({
            url: this.$http.adornUrl('accountinfo/appeal/reset/account/v1'),
            method: 'post',
            data: this.$http.adornData({
              userId: this.userId,
              contactEmail: this.contactEmail,
              naccount: this.email.trim(),
              verifyCode: this.emailCode.trim(),
              verifyToken: this.verifyToken,
              password: this.newPassword
            })
          }).then(data => {
            if (data.status === 200) {
              this.emailActive = 2
              var _this = this
              var outTimeFuct = setInterval(function () {
                if (_this.outTime > 0) {
                  _this.outTime--
                } else {
                  clearInterval(outTimeFuct)
                  location.href = _this.$baseUrl + "home-page"
                }
              }, 1000);
              outTimeFuct()
            }
          }).catch(err => {
            if (err.status !== 200) {
              if (err.data.Code == "USS-0151") {
                this.emailPassErrorCode = 4
              } else if (err.data.Code == "USS-0104") {
                this.emailPassErrorCode = 5
              } else if (err.data.Code == "USS-0100") {
                this.emailPassErrorCode = 6
              } else if (err.data.Code == "USS-0111") {
                this.emailPassErrorCode = 7
              } else if (err.data.Code == "USS-0140") {
                this.emailPassErrorCode = 8
              } else if (err.data.Code == "USS-0135") {
                this.emailPassErrorCode = 9
              } else if (err.data.Code == "USS-0144") {
                this.emailPassErrorCode = 10
              } else if (err.data.Code == "USS-0103") {
                this.emailPassErrorCode = 11
              }
              this.isfocus = true
            }
          })
        }
      },
      judgeProgressive() {
        if (!this.email) {
          this.isfocus = true
          this.emailerrorCode = 2
        } else if (!isEmail(this.email)) {
          this.isfocus = true
          this.emailerrorCode = 7
        } else if (!this.emailimgCode) {
          this.isfocus = true
          this.emailerrorCode = 1
        } else if (!this.emailCode) {
          this.isfocus = true
          this.emailerrorCode = 3
        } else {
          this.emailActive = 1
          this.emailerrorCode = 0;
        }
      },
      backEmailActive(index) {
        if (index == 0) {
          this.isTitle = 1
        } else if (index == 1) {
          this.emailActive = 0
        }
      },
      nextPas() {
        this.phonePassErrorCode = 0
        if (!this.phoneNnewPassword && !this.phoneNnewPassword2) {
          this.phonePassErrorCode = 1
          this.isfocus = true
        } else if (this.phoneNnewPassword != this.phoneNnewPassword2) {
          this.phonePassErrorCode = 2
          this.isfocus = true
        } else if (!isPsw(this.phoneNnewPassword)) {
          this.phonePassErrorCode = 3
          this.isfocus = true
        } else {
          this.$http({
            url: this.$http.adornUrl('accountinfo/appeal/reset/account/v1'),
            method: 'post',
            data: this.$http.adornData({
              userId: this.userId,
              contactEmail: this.contactEmail,
              naccount: this.phone.trim(),
              verifyCode: this.code.trim(),
              verifyToken: this.verifyToken,
              password: this.phoneNnewPassword
            })
          }).then(data => {
            if (data.status === 200) {
              this.phoneActive = 2
              var _this = this
              var outTimeFuct = setInterval(function () {
                if (_this.outTime > 0) {
                  _this.outTime--
                } else {
                  clearInterval(outTimeFuct)
                  location.href = _this.$baseUrl + "home-page"
                }
              }, 1000);
              outTimeFuct()
            }
          }).catch(err => {
            if (err.status !== 200) {
              if (err.data.Code == "USS-0151") {
                this.phonePassErrorCode = 4
              } else if (err.data.Code == "USS-0104") {
                this.phonePassErrorCode = 5
              } else if (err.data.Code == "USS-0100") {
                this.phonePassErrorCode = 6
              } else if (err.data.Code == "USS-0111") {
                this.phonePassErrorCode = 7
              } else if (err.data.Code == "USS-0140") {
                this.phonePassErrorCode = 8
              } else if (err.data.Code == "USS-0135") {
                this.phonePassErrorCode = 9
              } else if (err.data.Code == "USS-0144") {
                this.phonePassErrorCode = 10
              } else if (err.data.Code == "USS-0103") {
                this.phonePassErrorCode = 11
              }
              this.isfocus = true
            }
          })
        }
      },
      focus() {
        this.isfocus = false
      },
      backphoneActive(index) {
        if (index == 0) {
          this.isTitle = 1
        } else if (index == 1) {
          this.phoneActive = 0
        }
      },
      validCodeHandler() {
        if (!this.phone) {
          this.isfocus = true
          this.PhoneErrorCode = 2
        } else if (!this.code) {
          this.isfocus = true
          this.PhoneErrorCode = 3
        } else if (!isMobile(this.phone)) {
          this.isfocus = true
          this.PhoneErrorCode = 7
        } else if (!this.imgCode) {
          this.isfocus = true
          this.PhoneErrorCode = 1
        } else {
          this.PhoneErrorCode = 0;
          this.phoneActive = 1
        }
      },
      newImgHandler() {
        this.ttt = new Date().getTime();
        if (this.isTitle == 2) {
          this.emailimgUrl = setCapture(this.ttt);
        } else if (this.isTitle == 3) {
          this.imgUrl = setCapture(this.ttt);
        }
      },
      getCode() {
        if (this.time > 0 || this.emailtime > 0) {
          return;
        }
        if (this.isTitle == 2) {
          if (!this.email) {
            this.isfocus = true
            this.emailerrorCode = 2
          } else if (!this.emailimgCode) {
            this.isfocus = true
            this.emailerrorCode = 1
          } else if (!isEmail(this.email)) {
            this.isfocus = true
            this.emailerrorCode = 7
          } else {
            const ttt = this.ttt;
            this.ttt = new Date().getTime();
            if (this.isTitle == 2) {
              this.emailimgUrl = setCapture(this.ttt);
            } else if (this.isTitle == 3) {
              this.imgUrl = setCapture(this.ttt);
            }
            this.emailtime = 60;
            let timer = setInterval(() => {
              this.emailtime = this.emailtime - 1;
              if (this.emailtime <= 0) {
                clearInterval(timer);
              }
            }, 1000)
            this.emailerrorCode = 0;
            this.$http({
              method: 'post',
              url: this.$http.adornUrl('accountinfo/message/dynamiccode/v1/' + this.email.trim()),
              data: this.$http.adornData({
                type: "14",
                serialKey: (ttt).toString(),
                verifyToken: this.verifyToken,
                code: this.emailimgCode.trim(),
                lang: this.$i18n.locale
              })
            }).then(data => {
              if (data.status === 200) {
                this.emailerrorCode = 0;
              }
            }).catch(err => {
              if (err.status !== 200) {
                this.emailtime = 0;
                clearInterval(timer);
                this.isfocus = true
                this.emailerrorCode = 6;
                this.emailtime = 0;
              }else if (err.data.Code == "USS-0140") {
                this.emailPassErrorCode = 12
              }
            })
          }
        } else if (this.isTitle == 3) {
          if (!this.phone) {
            this.isfocus = true
            this.PhoneErrorCode = 2
          } else if (!isMobile(this.phone)) {
            this.isfocus = true
            this.PhoneErrorCode = 7
          } else if (!this.imgCode) {
            this.isfocus = true
            this.PhoneErrorCode = 1
          } else {
            const ttt = this.ttt;
            this.ttt = new Date().getTime();
            if (this.isTitle == 2) {
              this.emailimgUrl = setCapture(this.ttt);
            } else if (this.isTitle == 3) {
              this.imgUrl = setCapture(this.ttt);
            }
            this.time = 60;
            let timer = setInterval(() => {
              this.time = this.time - 1;
              if (this.time <= 0) {
                clearInterval(timer);
              }
            }, 1000)
            this.PhoneErrorCode = 0;
            this.$http({
              method: 'post',
              url: this.$http.adornUrl('accountinfo/message/dynamiccode/v1/' + this.phone.trim()),
              data: this.$http.adornData({
                type: "14",
                verifyToken: this.verifyToken,
                areacode: this.areacode,
                serialKey: ttt.toString(),
                lang: this.$i18n.locale,
                code: this.imgCode.trim()
              })
            }).then(data => {
              if (data.status === 200) {
                this.PhoneErrorCode = 0;
              }
            }).catch(err => {
              if(err.data.Code == "USS-0140") {
                this.time = 0;
                clearInterval(timer);
                this.isfocus = true;
                this.PhoneErrorCode = 6;
              }
            })
          }
        }

      },
      emailReset() {
        this.emailimgUrl = setCapture(this.ttt);
        this.isTitle = 2
      },
      PhoneReset() {
        this.imgUrl = setCapture(this.ttt);
        this.isTitle = 3
      },
      //输入授权码下一步
      next(formName) {
        this.authnCodeErrorMsg = ""
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var data = {
              contactEmail: this.contactEmail,
              authnCode: this.from.authnCode,
              userId: this.userId
            }

            this.$http({
              method: 'post',
              url: this.$http.adornUrl("accountinfo/appeal/authorization/code/verify/v1"),
              data: this.$http.adornData(data)
            }).then(data => {
              if (data.status === 200) {
                this.verifyToken = data.data.verifyToken
                this.contactEmail = data.data.contactEmail
                this.userId = data.data.userId
                this.isCode = true
                this.isTitle = 1
              }
            }).catch(err => {
              if (err.status !== 200) {
                if (err.data.Code == "USS-0140" || err.data.Code == "USS-0135") {
                  this.authnCodeErrorMsg = this.$t('appeal.authorizationError')
                } else if (err.data.Code == "USS-0143") {
                  this.authnCodeErrorMsg = this.$t('appeal.ACodeExpired')
                } else if (err.data.Code == "USS-0151") {
                  this.authnCodeErrorMsg = this.$t('appeal.requestLocked')
                }

              }
            })

          } else {
            return false;
          }
        });
      },
      //链接key值回调
      getauthnCode() {
        // var url = "http://idinner1.dev.surepush.cn/accountinfo/appeal?Zr%2BhFSHZITdojiRVVadhhuzd8oX6nw2fTutgc59wXx37%2BE8ktZ8mlqrf9X2%2Fpj7hScjRXFcrNmm3%2Bk0akZu4Gw%3D%3D"
        var url = location.href
        var getUrl = "/accountinfo/appeal/appealinfo/v1?encodeinfo=" + url.split("appeal?")[1]
        fetch(getUrl, {
            method: "GET",
            mode: 'cors'
            // credentials: "include"
          }).then(response => response.json())
          .then(data => {
            this.contactEmail = data.contactEmail
            this.userId = data.userId
          }).catch((err) => {
            this.dialogVisible = true
          })
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.getauthnCode()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style lang="scss">
 .el-steps--horizontal,
  .el-step__title {
    font-size: 16PX !important;
  }
  .el-checkbox{
    font-size: 14PX !important;
  }
  .el-button{
    border-radius: 4px!important;
  }
  .el-step__icon {
    height: 24px !important;
    font-size: 14px !important;
  }

  .el-step__icon.is-icon {
    width: 40PX !important;
    height: 40PX !important;
  }

  .el-step.is-horizontal .el-step__line {
    height: 2PX!important;
    top: 20px!important;
  }

  .el-step.is-center .el-step__line {
    left: 50% !important;
    right: -50% !important;
  }
 .el-step__title {
    line-height: 38PX !important;
  }
  .el-step__icon-inner {
    font-size: 25PX !important;
  }
  .el-dialog__body {
    text-align: center !important;
    margin-top: 20%;
  }

  .el-dialog {
    margin: 0 auto 50px !important;
    border-radius: 2px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .3) !important;
  }

  .el-dialog__header {
    padding: 20px 20px 10px !important;
  }

  .el-dialog__title {
    line-height: 24px !important;
    font-size: 18px !important;
  }

  .el-dialog__body {
    padding: 25px 25px 30px !important;
    font-size: 14px !important;
  }

  .el-dialog__footer {
    padding: 10px 20px 20px !important;
  }

  .el-button {
    padding: 12px 40px !important;
    font-size: 14px !important;
    border-radius: 4px !important;
    border: 1px solid #dcdfe6 !important;
    font-size: 14px !important;
  }

  // .el-form-item {
  //   margin-bottom: 22PX !important;
  // }

  .el-form-item__label {
    line-height: 40px !important;
    padding: 0 12px 0 0 !important;
    font-size: 14PX !important;
  }
  .el-form-item__content{
    font-size: 14PX;
    line-height: 40px !important;
  }
  .el-input {
    font-size: 14PX !important;
  }

  .el-input__inner {
    height: 40PX !important;
    border: 1px solid #DCDFE6 !important;
    border-radius: 4PX !important;
    padding: 0 15px;
    line-height: 40px;
  }

  .el-form-item__error {
    font-size: 12px !important;
    line-height: 1 !important;
  }

  .mobileAppeal {
    .el-step__title {
      font-size: 15PX !important;
      line-height: 18PX !important;
    }
    .el-form-item__label {
      width: 115PX !important;
    }
    .authorCode .el-form-item__label{
      line-height: 20PX!important;
      white-space: unset!important;
    }
    .el-form-item__content {
      margin-left: 115PX !important;
      font-size: 14px !important;
      line-height: 25PX !important;
      padding-bottom: 20PX !important;
    }

    .el-input {
      .el-input__inner {
        width: 200PX !important;
        font-size: 10PX;
      }
    }
  }
</style>
<style scoped lang="scss">
input{
  padding:0 10px;
}
  .mobileAppeal {
    .contactEmail1{
      margin-top: 10PX;
    }
    .from-div h3 {
      font-size: 16PX;
    }
    .card-on{
      div{

      padding-bottom: 0;
      }
      .email-logo{
        position: relative;
        top:3PX;
      }
      h2{
        padding:15PX 0;
        vertical-align: unset;
      }
      .text{
        vertical-align: middle;
        margin:0 10PX;
      }
      .link{
        vertical-align: middle;
        a{
          font-size: 18PX;
          text-decoration: none;
          color:#3E8DDD;
          
        }
        img{
          width: 10PX;
          height: 10PX;
        }
      }
    }
    .card-div {
      padding: 0 25PX 100PX 25PX; 
     
    }

    .el-form-item {
      margin-left: -10PX !important;
    }

    .main-title {
      padding: 0 25PX;
    }
    .mobileEmail,.mobilePhone{
      margin-bottom: 20PX;
      h2{
        font-size: 18PX;
      }
      p{
        font-size: 14PX;
        line-height: 20PX;
      }
    }
  }

  .from-div h3 {
    font-size: 16PX;
  }

  .btnDis {
    background: #b3b3b3 !important;
    cursor: auto !important;
  }

  .btn-div {
    margin-left: 120PX;
    margin-top: 40PX;
  }

  input:disabled {
    background: #fff !important;
  }

  .contentBox {
    padding-top: 50PX;

    >.left {
      width: 30%;
      margin-left: 5%;

      >div {
        background-color: #ffffff;
        height: 310PX;
        text-align: center;
        position: relative;

        img {
          width: 100PX;
          margin: 7% 0 5%;
        }

        p {
          height: 31PX;
          font-size: 14PX;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: left;
          padding: 0 30PX;
        }

        >div {
          position: absolute;
          bottom: 20PX;
          width: 100%;

          a {
            font-size: 16PX;
            font-weight: bold;
            color: rgba(62, 141, 221, 1);
          }
        }
      }

      h2 {
        font-size: 22PX;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 18PX;
      }
    }

    >.left:first-child {
      margin-left: 0;
    }
  }

  .setUserInfoBox {
    background: linear-gradient(0deg, rgba(64, 180, 210, 1), rgba(88, 159, 228, 1));
    width: 100%;
    height: 160PX;
    position: relative;
    overflow: hidden;

    .userInfoBox {
      >img {
        width: 74PX;
        height: 74PX;
        margin-top: 40PX;
      }

      .userInfoText {
        margin-top: 38PX;
        margin-left: 18PX;

        .username {
          font-size: 22PX;
          font-weight: bold;
          margin-bottom: 14PX;
        }

        div {
          font-size: 16PX;
          color: #ffffff;

          a {
            color: #EFF5FA;
          }

          p {
            color: #EFF5FA;
          }

          p:first-child {
            a {
              margin-left: 30PX;
            }
          }
        }

        div p:last-child {
          margin-top: 4PX;
        }
      }
    }
  }

  .emailMode {
    display: flex;

  }

  .equallywh {
    width: 320PX;
    height: 40PX;
    background: #FFFFFF;
    border: 1PX solid #dddddd;
    border-radius: 4PX;
    position: relative;
    margin: 10PX;
    display: flex;

    >input {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 4PX;
    }

    >button {
      cursor: pointer;
      width: 100%;
      height: 100%;
      border: none;
      background: #3E8DDD;
      color: #fff;
      text-align: center;
      border-radius: 4PX;
    }

  }

  .equallywhb {
    width: 320PX;
    // height:40PX;
    margin: 10PX;
    p{
      font-size: 14PX;
    }
  }

  .verificationmode {
    display: flex;
    justify-content: center;
    align-items: center;
    h2{
      font-size: 16PX;
    }
    span{
      font-size: 14PX;
    }
    img{
      // width: 40PX;
      height: 40PX;
    }
  }

  .verificationmode.setupSuccess {
    flex-direction: column;
    -webkit-flex-direction: column;
  }

  .makeCode {
    width: 320PX;
    height: 40PX;
    display: flex;
    justify-content: space-around;
    margin: 10PX;

  }

  // .leftCode {
  //   width: 170PX;
  //   height: 40PX;
  //   border: 1PX solid #dddddd;
  //   border-radius: 4PX;
  //   // position: relative;
  //   float: left;

  //   >input {
  //     width: 88%;
  //     height: 100%;
  //     border: none;
  //     background:red;
  //     margin-top:-5PX;
  //   }
  // }

  // .rightCode {
  //   width: 146PX;
  //   height: 40PX;
  //   border: 1PX solid #dddddd;
  //   border-radius: 4PX;
  //   float: right;
  //   >input {
  //     width: 100%;
  //     height: 100%;
  //     border: none;
  //   }
  // }
  .emailText{
    height: 40PX;
    line-height: 40PX;
    border:none;
    border:1PX solid #ddd;
    border-radius: 4PX;
    width: 75%;
  }
  .imgCodeE{
    width: calc(100% - 75%);
    border:1px solid #ddd;
    border-radius: 4PX;
  }

  .btnSucc {
    width: 152PX;
    height: 40PX;
    border-radius: 4PX;
    line-height: 40PX !important;

    >a {
      text-decoration: none;
      width: 100%;
      height: 100%;
      border: none;
      background: none;
      color: #000;
      display: block;
      text-align: center;
      font-size: 14PX;
    }
  }

  .returnLeft {
    border: 1PX solid #B8B8B8;
    background: #D7D7D7;
  }

  .nextRight {
    background: #3E8DDD !important;
    color: #FFF !important;
  }

  .nextRight>a {
    color: #FFF !important;

  }

  .eis-form-steps {
    display: flex;
    justify-content: center;
  }

  .redwarn {
    margin: 10PX;
    color: red;
    font-size: 12PX;
  }

  .error {
    position: absolute;
    right: 18PX;
    top: 7PX;
    color: #ef392b;
    font-size: 12PX;
    display: none;
  }






  .email-logo {
    margin-left: 23PX;
    width: 20PX;
    height: 20PX;
  }

  .card-on>h2 {
    display: inline-block;
    padding: 30PX 25PX 22PX 0;
    text-align: left;
    font-size: 18PX;
    vertical-align: super;
  }

  .card-on>span {
    display: inline-block;
    padding: 0 30PX 30PX 40PX;
    text-align: left;
    font-size: 16PX;
  }

  .card-on>div {
    // position: absolute;
    bottom: 20PX;
    // width: 100%;
    text-align: center;
    padding-bottom: 20PX;
  }

  .card-on {
    cursor: pointer;
    background-color: #fff;
    // height: 290PX;
    position: relative;
    border: 1PX solid #ddd;
    border-radius: 8PX;
  }

  .card-div {
    margin-top: 50PX;
    padding: 0 14%;
    overflow: hidden;
    padding-bottom: 100PX;
    // margin-bottom: 100PX;
  }

  .main-title {
    padding: 25PX 14% 45PX;
    border-bottom: 1PX solid #ddd;
    background-color: #ffffff;
    line-height: 40PX;
    position: relative;
    overflow: hidden;

    h2 {
      font-size: 18PX;
      font-weight: bold;
      color: #666 !important;
      line-height: 24PX;
    }

    p {
      font-size: 16PX;
      color: #666 !important;
      margin-bottom: 20PX;
      line-height: 20PX;
    }
  }

  .card-title {
    margin-bottom: 18PX;
    display: block;
    font-size: 19PX;
    font-weight: 700;
  }

  .backSpan {
    display: block;
    cursor: pointer;
    color: #3E8EDE !important;
    padding: 0 14%;
    margin-top: 100PX;
  }

  .back-img {
    margin-bottom: -4PX;
    width: 16PX;
    height: 16PX;
  }

  .center {
    padding: 0 14%;
    height: 100%;
    width: 100%;
  }
  .note1{
    margin-top: 20PX;
    color:#666666;
    font-size: 14PX;
    width: 320PX;
  }
  .dialogLink{
    margin-top: 150PX;
    text-align: center;
    .DialoglinkExpired{
      display: block;
      font-size: 18PX;
      margin-bottom: 10PX;
      padding:0 10PX;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/appeal/appeal.vue